export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.replace(/^data:(.*,)?/, '')); // Se SYDLE ONE der problema, tirar o replace
    reader.onerror = error => reject(error);
  });
}